import "./App.css";

import React from "react";

import MobileApp from "./MobileApp";
import DesktopApp from "./DesktopApp";


function App() {
  const isMobile = window.matchMedia("(hover: none)").matches;
  //console.log("isMobile :", isMobile)

  return isMobile ? <MobileApp /> : <DesktopApp />;
}

export default App;
